module.exports = __webpack_public_path__ + "static/media/car-door.a4ea9160.svg";